import ControlViewModel from '@/ViewModels/ControlViewModel';
import * as DateHelper from '@/Utility/DateHelper';
import {IDateAndOrTimePickerViewModelConstructorParameter} from "#/DefaultViewExtensionInterfaces";

export default class DateAndOrTimePickerViewModelBase extends ControlViewModel {

    /**
     * Der DateTime-String vom .NET
     */
    public value: KnockoutObservable<string>;

    /**
     * Der vom Benutzer eingegebene Text
     * Die Subscriber muessen auch benachrichtigt werden, wenn sich der Wert von rawValue zum selben Wert aendert, damit die Validierung immer angestossen wird.
     */
    public rawValue: KnockoutComputed<string>;

    /**
     * Ein Placeholder falls das Control keine Eingabe enthaelt
     */
    public placeholder: KnockoutComputed<string>;

    /**
     * Das Date-Objekt
     */
    public date: KnockoutObservable<Date>;

    /**
     * Ergebnis des ValidityState fuer das HTMLInputElement
     */
    public validity: KnockoutObservable<boolean>;

    private onResettedCallback: VoidFunction;

    public constructor(protected params: IDateAndOrTimePickerViewModelConstructorParameter) {
        super(params);
        this.value = this.observableOrDefault(params.value, '');
        this.validity = this.observableOrDefault(params.isValid, true);
        this.defineSubscription(this.validity, () => {
            this.rawValue.notifySubscribers();
        });
        const dateValue = this.observableOrDefault(this.value(), '');
        this.date = this.definePureComputed({
            read: () => {
                // eigenes Observable fuer date Computed wird benoetigt, um sicher zu gehen, dass Aenderungen bei date vor rawValue getriggert werden
                const value = dateValue();
                const date = DateHelper.parseDotNetDateTimeString(value);
                return date;
            },
            write: (date: Date) => {
                this.rawValue(this.parseToHtmlDateTimeString(date));
            }
        });
        this.rawValue = this.defineComputed({
            read: () => {
                const value = this.value();
                return this.parseToHtmlDateTimeString(value);
            },

            write: (rawValue) => {
                const value = this.parseToDotNetString(rawValue);
                // Sicherstellen, dass das Update von date als erstes passiert, da verschiedene Controls davon ausgehen, dass das date den aktuellsten Wert hat
                dateValue(value);
                this.value(value);
            }
        });

        this.placeholder = this.createPlaceHolder();
        this.onResettedCallback = () => { };
    }

    /**
     * Der Platzhalter fuer das Eingabefeld
     */
    protected createPlaceHolder(): KnockoutComputed<string> {
        return null;
    }

    /**
     * Wandelt den Wert in einen DotNetString um
     * @param date
     */
    protected parseToDotNetString(date: string): string {
        return '';
    }

    protected parseToHtmlDateTimeString(date: string | Date): string {
        return '';
    }

    public onResetted(callback: VoidFunction) {
        this.onResettedCallback = callback;
    }

    /**
     * @override 
     * @inheritdoc
     */
    public resetValue(): void {
        this.value(null);
        this.rawValue(null);
        this.validity(true);
        this.value.notifySubscribers();
        this.rawValue.notifySubscribers();
        this.onResettedCallback();
    }
}